// @ts-expect-error not migrated to TS yet
import KnowledgeBaseButton from 'ui-addon-i18n/components/KnowledgeBaseButton';
import FormattedJSXMessage from 'I18n/components/FormattedJSXMessage';
import { jsx as _jsx } from "react/jsx-runtime";
function ManageAccessDescription() {
  return /*#__PURE__*/_jsx(FormattedJSXMessage, {
    elements: {
      KnowledgeBaseButton
    },
    message: "email-management.assignTeams.assignTo.body_jsx",
    options: {
      url: 'https://knowledge.hubspot.com/user-management/hubspot-user-permissions-guide#marketing-tools',
      external: true
    }
  });
}
export default ManageAccessDescription;